import sales from './sales'
import reconciliation from './reconciliation'
import delivery from './delivery'
import financial from './financial'

export default {
  namespaced: true,
  modules: {
    sales,
    reconciliation,
    delivery,
    financial,
  },
  state: {},
  mutations: {},
  actions: {},
}
